import React, { useEffect, useMemo, useState } from 'react';
import intl from 'react-intl-universal';
import { Radio, Space, Select } from 'antd';
import { getCurrencySymbol } from 'Utils/utils';
import _isEmpty from 'lodash/isEmpty';
import { store } from 'Store/store.index';

const BundleProdPlanDetail = (props) => {
  const { plans, setLicense, setLicensePrice, setLicenseSymbol, appCode, currencyList, getPrice } = props;

  const BilledMonthly = intl.formatMessage({ id: 'account.BilledMonthly' });
  const BilledYearly = intl.formatMessage({ id: 'account.BilledYearly' });
  const BilledYearMonthly = intl.formatMessage({ id: 'account.BilledYearMonthly' });
  const Month = intl.formatMessage({ id: 'account.Month' });
  const Year = intl.formatMessage({ id: 'account.Year' });

  const [symbol, setSymble] = useState('');
  const [price, setPrice] = useState(0);
  const [unit, setUnit] = useState('');
  const [curCurrency, setCurCurrency] = useState('');

  const { isEdu } = store.userStore;
  const [licenseType, setLicenseType] = useState('monthly-year');

  const PriceUnitKeyMap = useMemo(() => {
    return {
      'monthly-year': {
        price: 'subscription-monthly-year', unit: Month,
      }, 'yearly': {
        price: 'subscription_discount_price', unit: Year,
      }, 'monthly': {
        price: 'subscription-monthly_discount_price', unit: Month,
      },
    };
  }, []);

  useEffect(() => {
    if (_isEmpty(plans) || !licenseType) return;

    if (appCode === 'pdf_editor_cloud_education') {
      setLicenseType('yearly');
    }

    //symbol
    const { code, symbol } = plans.currentCurrency;
    const showSymbol = getCurrencySymbol(code, symbol);
    setSymble(showSymbol);
    setCurCurrency(code);
    setLicenseSymbol(showSymbol);

    //price
    const { price: priceKey, unit: unitTip } = PriceUnitKeyMap[licenseType];
    const curPrice = Number(plans[priceKey] || 0);
    setPrice(curPrice);
    setUnit(unitTip);
    setLicense(licenseType);
    setLicensePrice(curPrice);
  }, [plans, licenseType]);

  const getRadios = () => {
    if (isEdu) {
      if (appCode === 'pdf_editor_cloud_education') {
        return (<>
          <Radio value='yearly'>{BilledYearly}</Radio>
        </>);
      }
      return (<>
        <Radio value='monthly-year'>{BilledYearMonthly}</Radio>
        <Radio value='yearly'>{BilledYearly}</Radio>
      </>);
    }

    return (<>
      <Radio value='monthly-year'>{BilledYearMonthly}</Radio>
      <Radio value='yearly'>{BilledYearly}</Radio>
      <Radio value='monthly'>{BilledMonthly}</Radio>
    </>);
  };

  const changeCurrency = (v) => {
    setCurCurrency(v);
    getPrice(v);
  };

  return (<>
    <div className='price-b-c'>
      <div className='pbc-left'>
        {price === 0 ? (
          <i>--/--</i>
        ) : (
          <>
            <span>{symbol}{price}</span>
            <span>/{unit}</span>
          </>
        )}
      </div>
      {isEdu && <Select value={curCurrency} onChange={changeCurrency} size='small' virtual={false} bordered={false} options={currencyList} />}
    </div>
    <Radio.Group onChange={e => setLicenseType(e.target.value)} value={licenseType}>
      <Space direction='vertical'>
        {getRadios()}
      </Space>
    </Radio.Group>
  </>);
};
export default BundleProdPlanDetail;